import {
  SET_INDUSTRY_DATA,
  INDUSTRY_FETCHING_INIT,
  INDUSTRY_FETCHING_COMPLETED,
} from "./types";
const initialState = {
  _industry: [],
  _fetching: false,
  _refetch: false,
  _selectedIndustry: "",
  _selectedIndustry_id: "",
  _selectedIndustry_active: true,
  _disableBtn: false,
  _popUpEdit: false,
  _dialogBox: false,
  _industryPage: 1,
  _industryPerpage: 20,
  _industryTotalCount: 0,
};

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case SET_INDUSTRY_DATA:
      return { ...state, ...action.payload };
    case INDUSTRY_FETCHING_INIT: {
      return { ...state, _fetching: true, _refetch: false };
    }
    case INDUSTRY_FETCHING_COMPLETED: {
      return { ...state, _fetching: false, ...action.payload };
    }
    default:
      return state;
  }
};
